import React from "react";
import { getMediaUrl } from "../services/api";

function BannerCarousel({
  banners = [],
  activeIndex = 0,
  imageStyle,
  desktopImageStyle,
  laptopImageStyle,
  desktop = false,
  laptop = false,
  fallback = null,
  altPrefix = "Banner",
}) {
  const items = Array.isArray(banners) ? banners.filter((item) => item?.image_url) : [];

  if (!items.length) {
    return fallback;
  }

  const safeIndex = Math.min(Math.max(activeIndex, 0), items.length - 1);
  const slideWidth = 100 / items.length;

  return (
    <div style={viewport}>
      <div
        style={{
          ...track,
          width: `${items.length * 100}%`,
          transform: `translate3d(-${safeIndex * slideWidth}%, 0, 0)`,
        }}
      >
        {items.map((banner, index) => (
          <div
            key={banner.id || banner.image_url || index}
            style={{
              ...slide,
              width: `${slideWidth}%`,
            }}
          >
            <div style={surface}>
              <img
                src={getMediaUrl(banner.image_url)}
                alt={banner.title || `${altPrefix} ${index + 1}`}
                style={{
                  ...baseImage,
                  ...(imageStyle || {}),
                  ...(desktop ? desktopImageStyle || {} : null),
                  ...(laptop ? laptopImageStyle || {} : null),
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const viewport = {
  width: "100%",
  overflow: "hidden",
  borderRadius: "inherit",
};

const track = {
  display: "flex",
  transition: "transform 0.92s cubic-bezier(.2,.82,.2,1)",
  willChange: "transform",
};

const slide = {
  flexShrink: 0,
  padding: 0,
};

const surface = {
  width: "100%",
  height: "100%",
  borderRadius: "inherit",
  background: "linear-gradient(135deg, rgba(255,252,245,.42) 0%, rgba(255,250,236,.18) 100%)",
  overflow: "hidden",
};

const baseImage = {
  width: "100%",
  display: "block",
  objectFit: "contain",
  objectPosition: "center center",
};

export default BannerCarousel;
